var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"about-title-container"},[_c('h1',{staticClass:"title"},[_vm._v(" "+_vm._s(this.title))])])
}
var staticRenderFns = []

export { render, staticRenderFns }